import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div>
            <div className='notFound-container '>
            </div>
        </div>
    );
};

export default NotFound;